// extracted by mini-css-extract-plugin
export default {"wrapper":"Scale_wrapper_UguYg","content":"Scale_content_g1rUN"};